import * as THREE from "three";
import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from "@material-ui/core/InputLabel";
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from '@material-ui/core/styles'
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
import { AddIcon } from './formUtil';
import {toast} from 'react-toastify';
import * as helptext from './helptext';

const FormAssembleFd = () => {
  const style         = SideStyle();
  const setParam      = Param.Get('setParam');
  const assembleAk    = Param.Get('assembleAk');
  const setControl    = Control.Get('setControl')

  const useStyles = makeStyles({
    whiteText: {
      color: 'white',
    },
  });

  const classes = useStyles();
  

  useEffect(() => {
    toast('Adjust the alignment paramters.');
  }, []);

  const handleValue = (e) => {
    setParam(s => {s.assembleAk[e.target.name] = Number(e.target.value)});
  };

  return (
    <div className={style.outside}>
      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <FormControl fullWidth>
          <InputLabel>Adapter</InputLabel>
          <Select
            type='number'
            name='adapter'
            defaultValue={assembleAk.adapter}
            value={assembleAk.adapter}
            onChange={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            className={classes.whiteText}
          >
            <MenuItem value={0}>Double Clamp 32</MenuItem>
            <MenuItem value={1}>Double Clamp 40</MenuItem>
            <MenuItem value={2}>Double Clamp 45</MenuItem>
            <MenuItem value={3}>Double Clamp 50</MenuItem>
            <MenuItem value={4}>Double Clamp 55</MenuItem>
            <MenuItem value={5}>Double Clamp 60</MenuItem>
            <MenuItem value={6}>Double Clamp 75</MenuItem>
            <MenuItem value={7}>Cross Slide 00</MenuItem>
            <MenuItem value={8}>Cross Slide 10</MenuItem>
            <MenuItem value={9}>Cross Slide 20</MenuItem>
            <MenuItem value={10}>Cross Slide 30</MenuItem>
            <MenuItem value={11}>Cross Slide 40</MenuItem>
            <MenuItem value={12}>Cross Slide 50</MenuItem>
            <MenuItem value={13}>Female Pyramid</MenuItem>
          </Select>
        </FormControl>

        <TextField
          id='filled-number'
          name='flexionExtension'
          label='-Extension/+Flexion'
          type='number'
          defaultValue={assembleAk.flexionExtension}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkFdFlextionExtention; s.explanationImg = './static/ak/img/assembleAkFdFlextionExtention.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='°'
            //   helptext={helptext.assembleAkFdFlextionExtention}
            //   title='-Extension/+Flexion'
            //   imgSrc='./static/ak/img/assembleAkFdFlextionExtention.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-100, 
            max:100,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='adductionAbduction'
          label='-Adduction/+Abduction'
          type='number'
          defaultValue={assembleAk.adductionAbduction}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkFdAdductionAbduction; s.explanationImg = './static/ak/img/assembleAkFdAdductionAbduction.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">°</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='°'
            //   helptext={helptext.assembleAkFdAdductionAbduction}
            //   title='-Adduction/+Abduction'
            //   imgSrc='./static/ak/img/assembleAkFdAdductionAbduction.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-100, 
            max:100,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='socketRotation'
          label='-Inner/+Outer rotation'
          type='number'
          defaultValue={assembleAk.socketRotation}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkFdSocketRotation; s.explanationImg = './static/ak/img/assembleAkFdSocketRotation.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">°</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='°'
            //   helptext={helptext.assembleAkFdSocketRotation}
            //   title='-Inner/+Outer rotation'
            //   imgSrc='./static/ak/img/assembleAkFdSocketRotation.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-100, 
            max:100,
            step:1
          }}
        />


        <TextField
          id='filled-number'
          name='socketMl'
          label='Socket ML'
          type='number'
          defaultValue={assembleAk.socketMl}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkFdSocketMl; s.explanationImg = './static/ak/img/assembleAkFdSocketMl.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm'
            //   helptext={helptext.assembleAkFdSocketMl}
            //   title='Socket ML'
            //   imgSrc='./static/ak/img/assembleAkFdSocketMl.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-100, 
            max:100,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='socketAp'
          label='Socket AP'
          type='number'
          defaultValue={assembleAk.socketAp}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkFdSocketAp; s.explanationImg = './static/ak/img/assembleAkFdSocketAp.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm'
            //   helptext={helptext.assembleAkFdSocketAp}
            //   title='Socket AP'
            //   imgSrc='./static/ak/img/assembleAkFdSocketAp.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-100, 
            max:100,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='socketSi'
          label='Socket SI'
          type='number'
          defaultValue={assembleAk.socketSi}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.assembleAkFdSocketSi; s.explanationImg = './static/ak/img/assembleAkFdSocketSi.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm'
            //   helptext={helptext.assembleAkFdSocketSi}
            //   title='Socket SI'
            //   imgSrc='./static/ak/img/assembleAkFdSocketSi.png'
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-200, 
            max:200,
            step:1
          }}
        />
      </Grid>
    </div>
  );
}
export default FormAssembleFd;
